import { globalGetService } from '@/utils/globalApiServices';
import { ApprovedDca } from './types';

export const getApprovedDcas = async () => {
  const response = await globalGetService('mno/profile/approvedDca');
  return response?.ok ? (response.data as ApprovedDca[]) : [];
};
